module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_transcription-60f449444b778d189cc6812d4466a40a.svg";